var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseBtn',_vm._g({attrs:{"id":_vm.id,"href":_vm.goToOkrTree(_vm.objectiveId)}},_vm.$listeners),[_c('img',{attrs:{"src":_vm.OKRsChartIcon,"height":"18","alt":"OKRs chart icon"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }